const styles = theme => ({
  wrapper: {
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.default
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/layouts/layout-funky/layout-funky.style.js